import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { Solution, SolutionList } from '../_types/solution';

export const getSolutions = async (
  signal?: AbortSignal,
  onError?: (errors: ServerErrorResponse) => void
): Promise<SolutionList> => {
  try {
    const url = `${baseApiUrl()}/admin-solution/v1/solutions`;
    const data: SolutionList = await fetcher({
      method: 'get',
      url,
      options: { signal },
    });

    // Transform the response to add key attribute
    const transformedData: SolutionList = {
      ...data,
      content: data.content.map((solution) => ({
        ...solution,
        key: solution.name.toLowerCase().replace(/\s+/g, '-'),
      })),
    };

    return transformedData;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export default function useSolutions(options: object = {}, onError?: (errors: ServerErrorResponse) => void) {
  return useQuery<SolutionList, ServerErrorResponse>(
    ['solutions'],
    async ({ signal }): Promise<SolutionList> => {
      return getSolutions(signal, onError);
    },
    {
      keepPreviousData: true,
      ...options,
    }
  );
}
